// The package a company has. Core: surveys shared by link, plus employer branding.
// Suite adds performance management, onboarding and surveys sent to members.
// Absent on a company = suite (see getCompanyPlan).
export enum CompanyPlan {
  CORE = 'core',
  SUITE = 'suite',
}
